import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css'
import Modal from 'component/Modal/index';
import TextField from 'component/TextField';
import TextArea from 'component/TextArea';

const EditModal = ({
  translate,
  toggleEdit,
  isOpen,
  parameter,
  onSubmit
}) => {
  const [copiedRow, setCopiedRow] = useState(null);

  const [formData, setFormData] = useState({
    dsValue: '',
    teValue: '',
    dsDocument: '',
  });

  const [originalData, setOriginalData] = useState({
    dsValue: '',
    teValue: '',
    dsDocument: '',
  });

  const [isChanged, setIsChanged] = useState(false); 

  if (!isOpen) return null;

  const handleCopy = (valueToCopy) => {
    navigator.clipboard.writeText(valueToCopy).then(() => {
      setCopiedRow(true);

      setTimeout(() => setCopiedRow(null), 2000); 
    });
  };

  const handleChange = (field, value) => {

    setFormData((prevData) => {
      const newFormData = {
        ...prevData,
        [field]: value || '', 
      };

      setIsChanged(
        Object.keys(newFormData).some((key) => newFormData[key] !== originalData[key])
      );

      return newFormData;
    });
  };

  const isBtnDisabled = () => !isChanged || 
           formData.dsValue === '' || 
           formData.dsDocument === '';

  const handleSave = () => {
    const updatedParameter = {
      ...parameter, 
      ...formData, 
    };
  
    onSubmit(updatedParameter)
    toggleEdit(false);
  };

  useEffect(() => {
    if (parameter) {
      const newFormData = {
        dsValue: parameter.dsValue || '',
        teValue: parameter.teValue || '',
        dsDocument: parameter.dsDocument || '',
      };
      setFormData(newFormData);
      setOriginalData(newFormData); 
    }
  }, [parameter]);
  

  return (
    <Modal
      title={"Editar parâmetro"} 
      confirmButtonText={translate('save_button_label')} 
      cancelButtonText={translate('cancel_button')} 
      disabledBgClickClosing
      isConfirmButtonDisabled={isBtnDisabled()}
      isOpen={isOpen}
      size="md"
      onCloseModal={() => toggleEdit(false)} 
      onConfirm={handleSave}
    >
      <>
        {parameter ? (
          <form action='#' onSubmit={handleSave} className='w-100 modal-system-parameter'>
            <div className='container-parameter'>
              <div className='parameter-item'>
                <div className="w-100 margin-top color-default">{translate('parameter')}</div>
                <div className="w-100 sm-margin-top">{parameter.nuParameter}<span className='margin-hyphen'>-</span>{parameter.dsKey}</div>  
              </div>
              
              <div>
                <div className="w-100 margin-top color-default">{translate('parameters.registered-idBranch')}</div>
                <div className="w-100 sm-margin-top">{parameter.idBranch === "0" ? "Todas" : parameter.idBranch}</div>
              </div>
              
            </div>
           
            <div className="w-100 margin-top color-default">{translate('parameters.dsDocument')}</div>
            <div className="w-100 sm-margin-top">{parameter.dsParameter}</div>

            <div className="w-100 margin-top-lg input-bg">
              <span
                className='copyValue positionCopyValue'
                onClick={() => handleCopy(parameter.dsValue)}
                style={{ cursor: 'pointer', color: copiedRow ? '#158110' : '#41A017' }}
              >
                {copiedRow ? 'Copiado!' : 'Copiar valor'}
              </span> 
              <TextArea
                required
                label={translate('parameters.dsValueType')}
                placeholder={"Digite o valor"}
                name={'dsValue'}
                fill
                onChange={(value) => handleChange('dsValue', value)}
                translate={translate}
                value={formData.dsValue || ''}
                validateValue={(v) => Boolean(v)}
              />
            </div>

            <div className="w-100 margin-top">
              <TextField
                required
                label={translate('parameters.teValue')}
                placeholder={"Digite o valor"}
                name={'teValue'} 
                fill
                onChange={(e) => handleChange('teValue', e.target.value)}
                translate={translate}
                value={formData.teValue}
                validateValue={(v) => Boolean(v)}
              />
            </div>

            <div className="w-100 sm-margin-top">
              <TextArea
                required
                label={translate('parameter-observations')}
                placeholder={"Digite uma observação sobre esse parâmetro"}
                name={'dsDocument'}
                fill
                onChange={(value) => handleChange('dsDocument', value)}
                translate={translate}
                value={formData.dsDocument}
                validateValue={(v) => Boolean(v)}
              />
            </div>
          </form>
        ) : (
          <div>{translate('parameter-list.not-found')}</div> 
        )}
      </>
    </Modal>
  );
};

EditModal.propTypes = {
  translate: PropTypes.func.isRequired,
  toggleView: PropTypes.func.isRequired,
  toggleEdit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  parameter: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};

export default EditModal;
export { EditModal };
